import type { OpeningHoursInfo, OpeningHoursInfoStateEnum } from "@finn-no/mobility-dealer-types";
import { Trans } from "@lingui/react";
import { Badge } from "@warp-ds/elements/react/badge";
import { ScreenReaderSeparator } from "./ScreenReaderSeparator.tsx";

export const OpeningHours = ({
  className = "",
  openingHoursInfo,
}: {
  className?: string;
  openingHoursInfo?: OpeningHoursInfo;
}) => {
  if (!openingHoursInfo) {
    return null;
  }

  const { openingsHours, state, stateText, activeOpeningHours } = openingHoursInfo;

  return (
    <div className={className}>
      <h3 className="mb-16">
        <Trans id="dealer.dealerOverview.openingHours" message="Opening hours" />
      </h3>
      <div className="flex gap-16 items-center mt-16 mb-8">
        <Badge variant={getBadgeVariantFromState(state)}>
          <span>{[stateText, activeOpeningHours].filter(Boolean).join(" · ")}</span>
        </Badge>
        <ScreenReaderSeparator />
      </div>
      <ul>
        {openingsHours.map((day) => (
          <li
            key={day.days}
            className={`flex justify-between border-b last-of-type:border-none py-8 ${day.active ? "font-bold" : ""}`}
          >
            <div>{day.days}</div>
            <div>{day.openTimeRange}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const getBadgeVariantFromState = (state: OpeningHoursInfoStateEnum) => {
  switch (state) {
    case "Open":
      return "positive";
    case "Closed":
      return "negative";
    case "ClosingSoon":
      return "warning";
    default:
      return "info";
  }
};
